import React, { useState, useImperativeHandle } from 'react';
import './style.scoped.css';

export interface LoadingModalRef {
  open: () => void;
  close: () => void;
}
const LoadingModal = React.forwardRef((props, ref) => {
  const [visible, setVisible] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      setVisible(true);
    },
    close: () => {
      setVisible(false);
    },
  }));

  if (!visible) return <div />;
  return (
    <div className="popupModal">
      <div className="loading-spinner-rolling">
        <div className="loading">
          <div></div>
        </div>
      </div>
    </div>
  );
});
export default LoadingModal;
